module.exports = __webpack_public_path__ + "static/media/thanos.89578b62.jpg";